import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

/*
 * Resets window scroll to the top on route changes
 * - navigating via Link maintains scroll-position; this let's us override
 *   that so new pages/routes always start at the top
 * - Note: skips POP navigation (back/forward) so the browser's remembered
 *   scroll position is preserved when traversing history
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (history.action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, history]);

  return null;
};

export default ScrollToTop;
